export default __webpack_public_path__ + "static/media/info_yellow.a9452613.png";